var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDisappointed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 88,
  height: 88,
  "aria-hidden": "true",
  role: "img"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFD95A"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29 0h30v88H29z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 6h52v76H18z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 12h64v64H12z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M6 18h76v52H6z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 30h88v28H0z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.6,
  style: {
    mixBlendMode: "multiply"
  }
}, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M29 0h30v88H29z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M18 6h52v76H18z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M12 12h64v64H12z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M6 18h76v52H6z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M0 30h88v28H0z"
})))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2D2D",
  d: "M41 59h6v6h-6z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2D2D",
  d: "M41 59h6v6h-6zm6 0h6v6h-6zm6 6h6v6h-6zm-24 0h6v6h-6zm6-6h6v6h-6zM18 47h6v6h-6zm46 0h6v6h-6zm-40-6h12v6H24zm28 0h12v6H52z"
}))));
export default SvgDisappointed;